import { useModal } from 'Store/modal';

import useDeleteTalkingPoint from 'Domain/brief-live/useDeleteTalkingPoint';
import useDeleteGiveaway from 'Domain/brief-live/useDeleteGiveaway';

import { giveawayDeleteActionText, talkingPointDeleteActionText } from 'Const/brief-live/view';

const useOpenDeleteModal = (selectedTab) => {
  const { onOpenModal } = useModal();

  const isTalkingPoint = selectedTab === 'talkingPoint';
  const deleteActionText = isTalkingPoint ? talkingPointDeleteActionText : giveawayDeleteActionText;

  const { mutate: onDeleteTalkingPoint } = useDeleteTalkingPoint();
  const { mutate: onDeleteGiveaway } = useDeleteGiveaway();

  const onOpenDeleteModal = (id) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: deleteActionText?.titleText,
      contentDescription: deleteActionText?.descriptionText,
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: deleteActionText?.submitButtonText,
      secondaryButtonText: deleteActionText?.cancelButtonText,
      onClickPrimaryButton: () => {
        if (isTalkingPoint) {
          onDeleteTalkingPoint(id);
        } else {
          onDeleteGiveaway(id);
        }
      },
    });
  };

  return { onOpenDeleteModal };
};

export default useOpenDeleteModal;
